import React, { useState } from "react";
import flyer1 from "../assets/flyer1.jpg";
import flyer2 from "../assets/flyer2.jpg";
import "../Styles/new.css";
import LoyaltyFormModal from "../components/LoyaltyFormModal";

const New = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [showForm, setShowForm] = useState(false);


  return (
    <>
      <div className="new-features-container">
        <div className="feature-box">
          <h2>What's New at RCS</h2>
          <h3>🏆 Loyalty Points System</h3>
          <p>
            Earn and redeem points every time you shop with us — rewarding you
            for your loyalty.
          </p>
          <p>
            Points can be redeemed for anything in store, be it bill payments,
            mmg, topup EVEN CASH!
            </p>
            <p>
            We aim to reward our loyal customers for their unwavering support, thus, everytime you shop at RCS,
            you are rewarded points, terms and conditions apply.
          </p>
          <button className="signup-btn" onClick={() => setShowForm(true)}>
          Sign Up for Loyalty Program
        </button>
      </div>

        <div className="flyer-stack">
          <img
            src={flyer1}
            alt="Flyer 1"
            onClick={() => setSelectedImage(flyer1)}
            className="clickable-flyer"
          />
          <img
            src={flyer2}
            alt="Flyer 2"
            onClick={() => setSelectedImage(flyer2)}
            className="clickable-flyer"
          />
        </div>
      </div>

      {/* ✅ Fullscreen Overlay */}
      {selectedImage && (
        <div className="flyer-overlay" onClick={() => setSelectedImage(null)}>
          <img src={selectedImage} alt="Enlarged Flyer" className="full-flyer" />
          <span className="close-btn" onClick={() => setSelectedImage(null)}>
            ✖
          </span>
        </div>
      )}
{showForm && <LoyaltyFormModal onClose={() => setShowForm(false)} />}
    </>
  );
};

export default New;
